// @flow

import * as React from 'react';
import List from './Components/List';

type Props = {
  order: any,
  listData: [],
  serviceTypes: [],
  editable: boolean,
  onClickAddOrderCaveat: Function,
  onClickRemoveOrderCaveat: Function,
  onClickDuplicateOrderCaveat: Function,
  onChangeOrderCaveatField: Function,
  onMoveOrderCaveat: Function,
}

export default class extends React.PureComponent<Props> {

  render () {

    const {
      order,
      listData,
      serviceTypes,
      editable,
      onClickAddOrderCaveat,
      onClickRemoveOrderCaveat,
      onClickDuplicateOrderCaveat,
      onChangeOrderCaveatField,
      onMoveOrderCaveat
    } = this.props;

    return (

      <React.Fragment>

        <List
          order={order}
          listData={listData}
          serviceTypes={serviceTypes}
          editable={editable}
          onClickAddOrderCaveat={onClickAddOrderCaveat}
          onClickRemoveOrderCaveat={onClickRemoveOrderCaveat}
          onClickDuplicateOrderCaveat={onClickDuplicateOrderCaveat}
          onChangeOrderCaveatField={onChangeOrderCaveatField}
          onMoveOrderCaveat={onMoveOrderCaveat}
        />

      </React.Fragment>

    )
  }
}